<template>
<div class="adddrawingwrapper">
  <div class="drawinginputs">
    <div class="div-block-39">
      <div class="div-block-40">
        <div class="text-block-22">Edit Color</div><a href="#" class="link-block-6 w-inline-block" @click="$emit('close-edit-color')"><img src="../../static/images/cancel.png" width="32" height="32" class="image-6"></a></div>
      <div class="adddrawinginputs">
        <el-form v-if="formInstance" :model="formInstance" label-position="top">
          <el-form-item label="Color Spec." required>
          <el-autocomplete
            placeholder="Color Spec."
            v-model="formInstance.name" :clearable="true"
            :fetch-suggestions="suggestColor"
            :trigger-on-focus="true"
            @select="selectColor">
          </el-autocomplete>
          </el-form-item>
          <el-form-item label="Color Tag">
            <el-color-picker v-model="formInstance.tag"></el-color-picker>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="adddrawingbuttons">
      <div class="form-warning" v-show="duplicateColor"><i class="material-icons" style="margin-right: 8px;">error</i><span> Duplicated color found, please user another color.</span></div>
      <el-button type="primary" round @click="saveColor" :disabled="formNotValid"> Save</el-button>
    </div>
  </div>
</div>
</template>

<script>
import drawingService from '../../static/js/drawing'

export default {
  name: 'EditColorForm',
  props: ['color', 'projectId'],
  data () {
    return {
      formInstance: this.color,
      originalColor: this.color.name,
      knowledgeBaseReady: false,
      knowledgeBase: {},
      suggestColors: []
    }
  },
  computed: {
    formNotValid: function () {
      return (this.formInstance.color === '' || this.duplicateColor)
    },
    duplicateColor: function () {
      if (!this.knowledgeBaseReady) {
        // console.log('KB NOT READY')
        return false
      }
      if (this.originalColor === this.formInstance.name) {
        return false
      }
      let color = this.formInstance.name.toLowerCase()
      // console.log(model, color)

      // search color base for duplicate
      for (let currentColor of this.knowledgeBase.colorBase) {
        // console.log('examining item =>', currentItem)
        if (currentColor.name.toLowerCase() === color) {
          return true
        }
      }
      return false
    }
  },
  mounted: function () {
    this.initColorBase()
  },
  watch: {
    projectId: function () {
      this.initColorBase()
    }
  },
  methods: {
    initColorBase: async function () {
      if (this.projectId && this.projectId !== 'NO_PROJECT_SELECTED') {
        await drawingService.initService(this.projectId)
        let knowledgeBase = await drawingService.fetchProjectKnowledgeBase(this.projectId)
        this.knowledgeBase = knowledgeBase
        let colorBase = knowledgeBase.colorBase ? knowledgeBase.colorBase : []
        // console.log(colorBase)
        this.suggestColors = colorBase.map(color => {
          return {
            name: color.name,
            tag: color.tag,
            value: color.name
          }
        })
        this.knowledgeBaseReady = true
      } else {
        this.suggestColors = []
        this.knowledgeBaseReady = false
      }
    },
    saveColor: async function () {
      let colorData = this.formInstance
      colorData.projectId = this.projectId
      let saveResult = await drawingService.saveEditColor(colorData)
      if (saveResult) {
        this.$emit('close-edit-color')
        // this.$notify({
        //   title: 'Success',
        //   message: 'Item updated',
        //   type: 'success',
        //   duration: 3000,
        //   offset: 64
        // })
      } else {
        // this.$notify({
        //   title: 'Error',
        //   message: 'Item note saved, please try again',
        //   type: 'error',
        //   duration: 3000,
        //   offset: 64
        // })
      }
    },
    selectColor: function () {
      let inputColor = this.formInstance.name
      // console.log(inputColor)
      for (let color of this.suggestColors) {
        if (inputColor === color.name) {
          this.formInstance.tag = color.tag
        }
      }
    },
    suggestColor: function (queryString, cb) {
      var colors = this.suggestColors
      var results = queryString ? colors.filter(this.colorFilter(queryString)) : colors
      cb(results)
    },
    colorFilter: function (queryString) {
      return (color) => {
        return (color.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    }
  }
}
</script>

<style scoped>
.form-warning {
  color: #e53935;
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditColorForm.vue